@if (langLoaded && trans) { @for (match of matchesN.slice().reverse() | slice: 0:limit; track $index) {
<span
    data-cy="app-last-matches-item"
    class="badge app-last-matches-badge {{ classOb(match) }}"
    data-toggle="tooltip"
    data-placement="top"
    data-html="true"
    title="<span class='latest-matches-tooltip'>{{ match.start_date | livDate : 'date' }} <br> {{
        getInfo(match)
    }}</span>"
>
    {{ getStatus(match) }}
</span>
} @if (spread) {

<div class="widget-team__form-text">
    @for (match of matchesN.slice().reverse() | slice: 0:limit; track $index) {
    <span
        class="app-last-matches-badge app-badge-text {{ classTextOb(match) }} badge-text-success"
        [innerHTML]="getTextStatus(match)"
    ></span>
    }
</div>
} }
